<template>
  <!-- 官方 GIS 图标按钮原位渲染，点击弹出 Google 账号选择 -->
  <div ref="buttonDiv" class="google-btn-wrap"></div>
</template>

<script>
import { LOGIN_GOOGLE } from "../../apis/user"
/* global google */
export default {
  computed: {
    i18n() {
      return this.$t("login")
    }
  },
  methods: {
    loginByGoogle(credential) {
      this.$loading(true)
      this.$post(
        LOGIN_GOOGLE,
        // 对齐 App：参数名 androidToken（GIS 返回 JWT idToken）
        { androidToken: credential },
        (resp) => {
          this.$loading(false)
          const _data = resp.data || resp || {}
          if (_data.token) {
            this.$store.commit("token", _data.token)
            this.$emit("success")
          } else {
            this.$toast(this.i18n.msg_fail_login)
          }
        },
        (error) => {
          console.log(error)
          this.$loading(false)
          this.$toast(this.i18n.msg_fail_login)
        }
      )
    },
    CredentialResponse(response) {
      console.log("Google JWT response: ", response)
      this.loginByGoogle(response.credential)
    },
    initGoogle() {
      try {
        google.accounts.id.initialize({
          client_id: process.env.VUE_APP_GOOGLE_APPID,
          callback: this.CredentialResponse,
          auto_select: false,
          cancel_on_tap_outside: true
        })
        // 原位渲染官方图标按钮，点击弹出 Google 账号选择
        google.accounts.id.renderButton(
          this.$refs.buttonDiv,
          {
            type: "icon",
            theme: "outline",
            size: "large",
            shape: "circle"
          }
        )
      } catch (err) {
        console.warn("initGoogle ~ err:", err)
      }
    },
    loadGoogle(d, s, id) {
      let js = ""
      let fjs = d.getElementsByTagName(s)[0]
      if (d.getElementById(id)) {
        return
      }
      js = d.createElement(s)
      js.id = id
      js.src = "https://accounts.google.com/gsi/client"
      js.onload = () => {
        this.initGoogle()
      }
      fjs.parentNode.insertBefore(js, fjs)
    }
  },
  mounted() {
    // SDK 已就绪则直接 init；脚本在途则监听 load，避免 google 未定义被 catch 吞掉
    const script = document.getElementById("google-jsplatform")
    if (window.google && window.google.accounts && window.google.accounts.id) {
      this.initGoogle()
    } else if (script) {
      script.addEventListener("load", () => {
        this.initGoogle()
      })
    } else {
      this.loadGoogle(document, "script", "google-jsplatform")
    }
  }
}
</script>

<style lang="less" scoped>
// 官方图标按钮容器：与 Apple 图标视觉高度对齐（官方 icon 按钮高 40px）
.google-btn-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}
</style>
